import { createContext } from 'react';

import ManagersRolesStore from './ManagersRolesStore';

const ManagersRolesStoreContext = createContext<{
  store: ManagersRolesStore | null;
}>({
  store: null
});

const ManagersRolesStoreProvider = ManagersRolesStoreContext.Provider;

export { ManagersRolesStoreProvider, ManagersRolesStoreContext };
